import { __assign, __rest } from "tslib";
import React from 'react';
import { useFormContext, useController } from 'react-hook-form';
import DollarPriceInput from '../../../../../../DollarPriceInput';
import EarningsDisplay from '../../../../../../EarningsDisplay';
var PriceField = function () {
    var _a;
    var _b = useFormContext(), control = _b.control, errors = _b.errors;
    var errorMessage = (_a = errors.price) === null || _a === void 0 ? void 0 : _a.message;
    var _c = useController({
        name: 'price',
        control: control,
    }).field, ref = _c.ref, fieldProps = __rest(_c, ["ref"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DollarPriceInput, __assign({}, fieldProps, { errorMessage: errorMessage, refInput: ref, showFTUE: false })),
        React.createElement(EarningsDisplay, { dollarPrice: fieldProps.value, productType: 'gallery' })));
};
PriceField.displayName = 'PriceField';
export default PriceField;
//# sourceMappingURL=PriceField.js.map